import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Button, GraphQLErrorMessage, Heading3, Input } from '@treams/treams-ui';

import { WorkspaceAdvanced } from './types';

export default function WorkspaceAlias(props: { workspace: WorkspaceAdvanced }) {
	const { t } = useTranslation();
	const [alias, setAlias] = useState(props.workspace.alias ?? '');
	const [update, { loading, error }] = graphql.useUpdateWorkspaceAliasMutation();

	useEffect(() => {
		setAlias(props.workspace.alias ?? '');
	}, [props.workspace.alias]);

	const save = useCallback(async () => {
		try {
			await update({
				variables: {
					input: {
						workspaceID: props.workspace.id,
						alias,
					},
				},
			});
		} catch {
			// Error is handled by the error state from the mutation hook
		}
	}, [update, props.workspace.id, alias]);

	return (
		<Box flexGrow={1} flexBasis={0} mt="30px">
			<Heading3 mb={2}>{t('settings.workspaces.alias.label')}</Heading3>
			{error && (
				<Box mb={2}>
					<GraphQLErrorMessage error={error.graphQLErrors?.[0] ?? error} />
				</Box>
			)}
			<Flex>
				<Input
					value={alias}
					onChange={setAlias}
					placeholder={t('settings.workspaces.alias.placeholder')}
					flexGrow={1}
					mr={2}
				/>
				<Button
					onClick={save}
					small
					title={t('common.save')}
					type="primary"
					flexGrow={0}
					flexShrink={0}
					disabled={loading || alias === props.workspace.alias}
				/>
			</Flex>
		</Box>
	);
}
